import { Input } from "antd";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { DatePicker, Divider, Modal } from "rsuite";
import { useNotification } from "../../../../../utils/notification";
import { selector } from "../../../../../api";
import moment from "moment";
import { ThousandSeparatorInput } from "../../../../../utils/inputNumber";
import { char, code } from "../../../../../utils";
import Confirmation from "../../../../../utils/confirmation";
import { gatewayCRUD } from "../../../../../actions/gateway";

const clearanceSchema = Yup.object().shape({
  date: Yup.string().required("This field is required"),
  amount: Yup.number()
    .required("This field is required")
    .typeError("This field must be a number"),
  reference: Yup.string().required("This field is required"),
});

const initialValues = {
  date: "",
  amount: "",
  reference: "",
  reason: "",
};

const cutoffDate = moment().subtract(8, "days").startOf("day");

export const CustomerInvoiceClearanceAdd = (props) => {
  const { open, setOpen, dataId } = props;
  const [loading, setLoading] = useState(false);
  const [index, setIndex] = useState(0);
  const openNotification = useNotification();
  const user = selector.User();

  const formik = useFormik({
    initialValues,
    validationSchema: clearanceSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { date, amount, reference, reason } = values;
      const created_by = user.id;
      const data = {
        date,
        amount,
        reference,
        reason,
        logs: dataId,
        created_by,
      };

      setLoading(true);
      setTimeout(() => {
        gatewayCRUD
          .addInvoiceClearance(data)
          .then(() => {
            openNotification(
              "success",
              "Success",
              "Thank you....! invoice clearance has been added",
            );
            setIndex(index + 1);
            resetForm();
            setLoading(false);
            setSubmitting(false);
            setOpen(false);
          })
          .catch((error) => {
            setLoading(false);
            setSubmitting(false);
            const responseData = error?.response?.data;
            let errorMessage = "Something went wrong. Please try again.";

            if (typeof responseData === "string") errorMessage = responseData;
            else if (responseData?.error) errorMessage = responseData.error;
            else if (responseData?.detail) errorMessage = responseData.detail;
            else if (responseData?.message) errorMessage = responseData.message;
            else if (typeof responseData === "object") {
              const firstKey = Object.keys(responseData)[0];
              const firstError = responseData[firstKey];
              if (Array.isArray(firstError)) errorMessage = firstError[0];
            }

            openNotification("error", "Error", errorMessage);
          });
      }, 2000);
    },
  });

  const handleSubmit = () => {
    formik.handleSubmit();
  };

  const handleConfirm = () => {
    Confirmation(
      `Dear ${char.toTitleCase(code.getFirstWord(user?.first_name))},`,
      "Do you want to clear selected control number...?",
      handleSubmit,
      null,
    );
  };

  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          formik.resetForm();
        }}
        size="md"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>New Clearance</Modal.Title>
        </Modal.Header>
        <Divider />
        <form>
          <Modal.Body>
            <div className="container">
              <div className="row align-items-center mb-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">
                    Payment Date <span className="text-danger">*</span>
                  </label>
                  <small
                    className="text-muted d-block fst-italic"
                    style={{ fontSize: "10px" }}
                  >
                    Please select payment date
                  </small>
                </div>
                <div className="col-md-8 position-relative">
                  <DatePicker
                    className={`form-control-custom w-100 pe-5 ${
                      formik.touched.date && formik.errors.date
                        ? "error"
                        : formik.touched.date &&
                            !formik.errors.date &&
                            formik.values.date
                          ? "success"
                          : ""
                    }`}
                    shouldDisableDate={(date) => {
                      return moment(date).isSameOrAfter(cutoffDate, "day");
                    }}
                    onClean={() => {
                      formik.setFieldValue("date", "");
                    }}
                    oneTap
                    size="large"
                    onBlur={() => formik.setFieldTouched("date", true)}
                    placeholder="Enter date"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "date",
                        moment(e).format("YYYY-MM-DD"),
                      );
                    }}
                  />
                  {formik.touched.date && formik.errors.date && (
                    <i className="bi bi-x-circle-fill text-danger form-control-custom-icon-error" />
                  )}
                  {formik.touched.date &&
                    !formik.errors.date &&
                    formik.values.date && (
                      <i className="bi bi-check-circle-fill text-success form-control-custom-icon-success" />
                    )}
                  {formik.touched.date && formik.errors.date && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      {formik.errors.date}
                    </div>
                  )}
                </div>
              </div>
              <div className="row align-items-center mb-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">
                    Reference Number <span className="text-danger">*</span>
                  </label>
                  <small
                    className="text-muted d-block fst-italic"
                    style={{ fontSize: "10px" }}
                  >
                    Please enter payment reference number
                  </small>
                </div>
                <div className="col-md-8 position-relative">
                  <Input
                    className={`form-control-custom pe-5 ${
                      formik.touched.reference && formik.errors.reference
                        ? "error"
                        : formik.touched.reference &&
                            !formik.errors.reference &&
                            formik.values.reference
                          ? "success"
                          : ""
                    }`}
                    size="large"
                    placeholder="Enter reference number"
                    {...formik.getFieldProps("reference")}
                  />
                  {formik.touched.reference && formik.errors.reference && (
                    <i className="bi bi-x-circle-fill text-danger form-control-custom-icon-error" />
                  )}
                  {formik.touched.reference &&
                    !formik.errors.reference &&
                    formik.values.reference && (
                      <i className="bi bi-check-circle-fill text-success form-control-custom-icon-success" />
                    )}
                  {formik.touched.reference && formik.errors.reference && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      {formik.errors.reference}
                    </div>
                  )}
                </div>
              </div>
              <div className="row align-items-center mb-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">
                    Paid Amount <span className="text-danger">*</span>
                  </label>
                  <small
                    className="text-muted d-block fst-italic"
                    style={{ fontSize: "10px" }}
                  >
                    Please enter paid amount
                  </small>
                </div>
                <div className="col-md-8 position-relative">
                  <ThousandSeparatorInput
                    className={`form-control-custom pe-5 ${
                      formik.touched.amount && formik.errors.amount
                        ? "error"
                        : formik.touched.amount &&
                            !formik.errors.amount &&
                            formik.values.amount
                          ? "success"
                          : ""
                    }`}
                    value={formik.values.amount}
                    size="large"
                    placeholder="Enter paid amount"
                    onChange={(e) => {
                      formik.setFieldValue(
                        "amount",
                        parseFloat(e.target.value),
                      );
                    }}
                    onBlur={() => formik.setFieldTouched("amount", true)}
                  />
                  {formik.touched.amount && formik.errors.amount && (
                    <i className="bi bi-x-circle-fill text-danger form-control-custom-icon-error" />
                  )}
                  {formik.touched.amount &&
                    !formik.errors.amount &&
                    formik.values.amount && (
                      <i className="bi bi-check-circle-fill text-success form-control-custom-icon-success" />
                    )}
                  {formik.touched.amount && formik.errors.amount && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      {formik.errors.amount}
                    </div>
                  )}
                </div>
              </div>
              <div className="row align-items-center mb-3">
                <div className="col-md-4">
                  <label className="form-label fw-bold">Reason</label>
                  <small
                    className="text-muted d-block fst-italic"
                    style={{ fontSize: "10px" }}
                  >
                    Please enter clearance reason
                  </small>
                </div>
                <div className="col-md-8 position-relative">
                  <Input.TextArea
                    className={`form-control-custom pe-5 ${
                      formik.touched.reason && formik.errors.reason
                        ? "error"
                        : formik.touched.reason &&
                            !formik.errors.reason &&
                            formik.values.reason
                          ? "success"
                          : ""
                    }`}
                    rows={5}
                    size="large"
                    placeholder="Enter clearance reason"
                    {...formik.getFieldProps("reason")}
                  />
                  {formik.touched.reason && formik.errors.reason && (
                    <i className="bi bi-x-circle-fill text-danger form-control-custom-icon-error" />
                  )}
                  {formik.touched.reason &&
                    !formik.errors.reason &&
                    formik.values.reason && (
                      <i className="bi bi-check-circle-fill text-success form-control-custom-icon-success" />
                    )}
                  {formik.touched.reason && formik.errors.reason && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      {formik.errors.reason}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Divider style={{ marginTop: -10 }} />
          <Modal.Footer>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 d-flex justify-content-start">
                  <span className="fs-18 text-danger"> * &nbsp;</span> Reuired
                  field
                </div>
                <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button
                    onClick={() => {
                      setOpen(false);
                      formik.resetForm();
                    }}
                    disabled={loading}
                    type="button"
                    className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                  >
                    <i class="ri-forbid-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                    disabled={formik.isSubmitting || !formik.isValid}
                    onClick={() => {
                      handleConfirm();
                    }}
                  >
                    {!loading && (
                      <span className="indicator-label">
                        <i class="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                        Save
                      </span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>

      {loading && (
        <div className="processing-overlay">
          <div className="processing-card">
            <div className="processing-spinner"></div>
            <div style={{ fontWeight: 600, fontSize: 16 }}>Saving Data...</div>
            <div style={{ fontSize: 13, color: "#6b7280" }}>
              Please do not close this window
            </div>
          </div>
        </div>
      )}
    </>
  );
};
